<template>
  <div class="more-license-card-list">
    <p class="list-title">
      {{ $t(' 建議更新相關證照') }}
    </p>
    <div class="license-cards">
      <LicenseCard
        v-for="(license_e,license_k) in _licenseList"
        :key="license_k"
        :card-content="license_e"
      />
    </div>
    <WsButton001
      v-if="licenseNumber <= licenseDemo.length"
      out-line
      medium-button
      @click="$_addCard(2)"
    >
      {{ $t('載入更多') }}
    </WsButton001>
  </div>
</template>
<script>
export default {
  name: "MoreLicenseCardList",
  props: {},
  data: () => ({
    licenseDemo: [
      {
        name: "污水排放許可證",
        system_subclasses: [
          {
            name: "水污染防治",
            leadingIcon: "icon-water",
          },
        ],
        content: [
          {
            title: "證號",
            text: "操證字第H1716-06號",
          },
          {
            title: "核准函號",
            text: "桃園市政府2015.09.16府環空字第1040243226號函",
          },
          {
            title: "效期",
            text: "2020.01.02-2121.01.30",
          },
        ],
      },
      {
        name: "污水排放許可證",
        system_subclasses: [
          {
            name: "水污染防治",
            leadingIcon: "icon-water",
          },
        ],
        content: [
          {
            title: "證號",
            text: "操證字第H1716-06號",
          },
          {
            title: "核准函號",
            text: "桃園市政府2015.09.16府環空字第1040243226號函",
          },
          {
            title: "效期",
            text: "2020.01.02-2121.01.30",
          },
        ],
      },
      {
        name: "污水排放許可證",
        system_subclasses: [
          {
            name: "水污染防治",
            leadingIcon: "icon-water",
          },
        ],
        content: [
          {
            title: "證號",
            text: "操證字第H1716-06號",
          },
          {
            title: "核准函號",
            text: "桃園市政府2015.09.16府環空字第1040243226號函",
          },
          {
            title: "效期",
            text: "2020.01.02-2121.01.30",
          },
        ],
      },
    ],
    licenseNumber: 2,
  }),
  computed: {
    _licenseList() {
      let licenseList = [];
      if (!this.licenseDemo) return licenseList;
      this.licenseDemo.forEach((license, licenseIndex) => {
        if (licenseIndex + 1 > this.licenseNumber) return;
        licenseList.push(license);
      });
      return licenseList;
    },
  },
  methods: {
    $_addCard(num) {
      this.licenseNumber += num;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/more-license-card-list";
</style>